class CalendarGridController {

  constructor($scope) {
    'ngInject';
    this.scope = $scope;
    // this.dateToday = new Date();
  }

  $onInit() {
    this.year = this.dateToday.getFullYear();
    this.month = this.dateToday.getMonth();
    this.day = this.dateToday.getDate();
    this.months = this.initMonths();
  }

  initMonths() {
    let months = [];

    for (let i = 0; i < 12; i++) {
      months.push(new Date(this.year, i, 1, 2, 0, 0));
    }

    return months;
  }

  showMobileCalendar() {
    return this.isMobileApp && this.loaded && !this.isMobileSchedule;
  }

  showTabletCalendar() {
    return !this.isMobileApp && this.loaded && this.isTabletResolution;
  }

  showDesktopCalendar() {
    return !this.isMobileApp && this.loaded && !this.isTabletResolution;
  }

  showMobileSchedule() {
    return this.isMobileApp && this.loaded && this.isMobileSchedule;
  }
}

export default CalendarGridController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarGrid/calendarGrid.controller.js